import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dw-record-popup-feature" }
const _hoisted_2 = { class: "dw-record-popup-feature__header" }
const _hoisted_3 = { class: "header__container" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "16",
  viewBox: "0 0 14 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.11111 4.11111V10.3333C4.11111 11.1924 4.80756 11.8889 5.66667 11.8889H10.3333M4.11111 4.11111V2.55556C4.11111 1.69645 4.80756 1 5.66667 1H9.23339C9.43967 1 9.6375 1.08194 9.78336 1.22781L13.2166 4.66108C13.3625 4.80694 13.4444 5.00478 13.4444 5.21106V10.3333C13.4444 11.1924 12.748 11.8889 11.8889 11.8889H10.3333M4.11111 4.11111H3C1.89543 4.11111 1 5.00654 1 6.11111V13.4444C1 14.3036 1.69645 15 2.55556 15H8.33333C9.4379 15 10.3333 14.1046 10.3333 13V11.8889",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.1406 1.827C13.141 1.827 13.1413 1.82735 13.1421 1.82807L14.1722 2.85843C14.173 2.85896 14.1731 2.85932 14.1733 2.85985C14.1734 2.86021 14.1734 2.86057 14.1733 2.86093C14.1733 2.86146 14.173 2.86182 14.1722 2.86253L9.03474 8.00003L14.1722 13.1375C14.173 13.1382 14.1731 13.1386 14.1733 13.1391C14.1734 13.1395 14.1734 13.14 14.1733 13.1404C14.1733 13.1407 14.173 13.1411 14.1722 13.1418L13.1419 14.172C13.1413 14.1727 13.141 14.1729 13.1406 14.1731C13.1402 14.1732 13.1398 14.1732 13.1394 14.1731C13.1388 14.1731 13.1385 14.1727 13.1378 14.172L8.00028 9.0345L2.86278 14.172C2.86206 14.1727 2.86171 14.1729 2.86117 14.1731C2.86076 14.1732 2.86033 14.1732 2.85992 14.1731C2.85956 14.1731 2.85921 14.1727 2.85849 14.172L1.82831 13.1416C1.8276 13.1411 1.82742 13.1407 1.82724 13.1404C1.82712 13.14 1.82712 13.1395 1.82724 13.1391C1.82724 13.1386 1.8276 13.1382 1.82831 13.1375L6.96581 8.00003L1.82831 2.86253C1.8276 2.86182 1.82742 2.86146 1.82724 2.86093C1.82712 2.86052 1.82712 2.86008 1.82724 2.85968C1.82724 2.85932 1.8276 2.85896 1.82831 2.85825L2.85867 1.82807C2.85921 1.82735 2.85956 1.82718 2.85992 1.827C2.86033 1.82687 2.86076 1.82687 2.86117 1.827C2.86171 1.827 2.86206 1.82735 2.86278 1.82807L8.00028 6.96557L13.1378 1.82807C13.1385 1.82735 13.1388 1.82718 13.1394 1.827C13.1398 1.82687 13.1402 1.82687 13.1406 1.827Z",
  fill: "black",
  "fill-opacity": "0.45"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "dw-record-popup-feature__container" }
const _hoisted_10 = { class: "container__row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, "Клиент", -1)
const _hoisted_12 = { class: "container__row" }
const _hoisted_13 = { class: "container__row" }
const _hoisted_14 = { class: "container__row" }
const _hoisted_15 = {
  key: 0,
  class: "container__row"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, "Количество накладных", -1)
const _hoisted_17 = ["href"]
const _hoisted_18 = {
  key: 1,
  class: "container__row"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", null, "Дата забора", -1)
const _hoisted_20 = {
  key: 2,
  class: "container__row"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", null, "Сектор", -1)
const _hoisted_22 = {
  key: 0,
  class: "container__row"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", null, "Курьер", -1)
const _hoisted_24 = {
  key: 1,
  class: "container__row"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", null, "Телефон курьера", -1)
const _hoisted_26 = { class: "container__row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", null, "Статус", -1)
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { style: {"margin-top":"8px"} }
const _hoisted_30 = { style: {"margin-top":"4px"} }
const _hoisted_31 = {
  key: 5,
  class: "container__row"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", null, "Статус ЛО", -1)
const _hoisted_33 = {
  key: 6,
  class: "container__row"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", null, "Забрано в: ", -1)
const _hoisted_35 = {
  key: 7,
  class: "container__row"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", null, "Доставлено в: ", -1)
const _hoisted_37 = {
  key: 0,
  class: "container__actions"
}
const _hoisted_38 = { class: "actions__row" }
const _hoisted_39 = {
  key: 1,
  class: "container__actions"
}
const _hoisted_40 = { class: "actions__row row--2" }
const _hoisted_41 = {
  key: 2,
  class: "container__actions"
}
const _hoisted_42 = { class: "actions__row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_status = _resolveComponent("dw-status")!
  const _component_dw_badge = _resolveComponent("dw-badge")!
  const _component_dw_wait_list_status = _resolveComponent("dw-wait-list-status")!
  const _component_dw_button = _resolveComponent("dw-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.featureEntity)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", null, [
                (_ctx.featureEntity.type === 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.isUnassignedTake)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("Неназначенный забор")
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("Забор")
                          ], 64))
                    ], 64))
                  : (_ctx.featureEntity.type === 2)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.isUndeliveredDelivery)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("Невыданная доставка")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("Доставка")
                            ], 64))
                      ], 64))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("a", {
                href: _ctx.featureEntity.type === 1 ? `/order/${(_ctx.featureEntity as DispatcherWorkplaceTake).orderId}` : `/invoice/${(_ctx.featureEntity as DispatcherWorkplaceDelivery).invoiceId}`,
                target: "_blank"
              }, [
                (_ctx.featureEntity.type === 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" №" + _toDisplayString((_ctx.featureEntity as DispatcherWorkplaceTake).orderNumber), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.featureEntity.type === 2)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" №" + _toDisplayString((_ctx.featureEntity as DispatcherWorkplaceDelivery).invoiceNumber), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_4),
              _createElementVNode("div", {
                class: "container__copy",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyNumber && _ctx.copyNumber(...args)))
              }, _hoisted_6)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(), _createElementBlock("svg", {
        class: "header__close",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
      }, _hoisted_8))
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.featureEntity)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", null, _toDisplayString(_ctx.featureEntity.companyName), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", null, [
                (_ctx.featureEntity.type === 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("Имя отправителя")
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.featureEntity.type === 2)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Имя получателя")
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, _toDisplayString(_ctx.featureEntity.fullName), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", null, [
                (_ctx.featureEntity.type === 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("Телефон отправителя")
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.featureEntity.type === 2)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Телефон получателя")
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, _toDisplayString(_ctx.featureEntity.phone), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", null, [
                (_ctx.featureEntity.type === 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("Адрес отправителя")
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.featureEntity.type === 2)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Адрес получателя")
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, _toDisplayString(_ctx.featureEntity.fullAddress), 1)
            ]),
            (_ctx.featureEntity.type === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", null, [
                    _createElementVNode("a", {
                      href: `/order/${(_ctx.featureEntity as DispatcherWorkplaceTake).orderId}`,
                      target: "_blank"
                    }, _toDisplayString((_ctx.featureEntity as DispatcherWorkplaceTake).invoicesCount), 9, _hoisted_17)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.featureEntity.type === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", null, _toDisplayString((_ctx.featureEntity as DispatcherWorkplaceTake).takeDate), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isUnassignedTake)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", null, _toDisplayString((_ctx.featureEntity as DispatcherWorkplaceTake).sectorName || '-'), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isTake || _ctx.isDelivery)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  (Boolean(_ctx.featureEntity.courierName))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("div", null, _toDisplayString(_ctx.featureEntity.courierName), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (Boolean(_ctx.featureEntity.courierName))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("div", null, _toDisplayString(_ctx.featureEntity.courierPhone), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              (Boolean(_ctx.featureEntity.statusName))
                ? (_openBlock(), _createBlock(_component_dw_status, {
                    key: 0,
                    "status-id": _ctx.featureEntity.statusId,
                    "status-name": _ctx.featureEntity.statusName
                  }, null, 8, ["status-id", "status-name"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_28, "-"))
            ]),
            (_ctx.featureEntity.downtimes.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(_ctx.featureEntity.downtimes, (downtime) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "container__downtime",
                    key: downtime.id
                  }, [
                    _createVNode(_component_dw_badge, { class: "dw-badge--red-light" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Зафиксирован простой")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_29, "Временной промежуток: " + _toDisplayString(downtime.startedAt) + " - " + _toDisplayString(downtime.endedAt), 1),
                    _createElementVNode("div", _hoisted_30, "Длительность: " + _toDisplayString(downtime.downtime) + " " + _toDisplayString(_ctx.declOfNum(downtime.downtime, ['минуту', 'минуты', 'минут'])), 1)
                  ]))
                }), 128))
              : _createCommentVNode("", true),
            (Boolean(_ctx.featureEntity.waitListStatus))
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _hoisted_32,
                  _createVNode(_component_dw_wait_list_status, {
                    "showing-icon": (_ctx.featureEntity.waitListStatus as DispatcherWorkplaceRecordWaitListStatus).source !== 'МПК',
                    "wait-list-status": (_ctx.featureEntity.waitListStatus as DispatcherWorkplaceRecordWaitListStatus)
                  }, null, 8, ["showing-icon", "wait-list-status"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.featureEntity.type === 1 && Boolean((_ctx.featureEntity as DispatcherWorkplaceTake).takenAt))
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("div", null, _toDisplayString((_ctx.featureEntity as DispatcherWorkplaceTake).takenAt), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.featureEntity.type === 2 && Boolean((_ctx.featureEntity as DispatcherWorkplaceDelivery).deliveredAt))
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("div", null, _toDisplayString((_ctx.featureEntity as DispatcherWorkplaceDelivery).deliveredAt), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.featureEntity.state !== 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                  (_ctx.isTake)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["actions__row", { 'row--2': !Boolean(_ctx.featureEntity.waitListStatus) }])
                        }, [
                          _createVNode(_component_dw_button, { onClick: _ctx.onChangeDate }, {
                            default: _withCtx(() => [
                              _createTextVNode("Перенести дату")
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          (!Boolean(_ctx.featureEntity.waitListStatus))
                            ? (_openBlock(), _createBlock(_component_dw_button, {
                                key: 0,
                                onClick: _ctx.onAddToWaitList
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Добавить в ЛО")
                                ]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_dw_button, { onClick: _ctx.onAssign }, {
                            default: _withCtx(() => [
                              _createTextVNode("Переназначить")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isUnassignedTake)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["actions__row", { 'row--2': !Boolean(_ctx.featureEntity.waitListStatus) }])
                        }, [
                          _createVNode(_component_dw_button, { onClick: _ctx.onChangeDate }, {
                            default: _withCtx(() => [
                              _createTextVNode("Перенести дату")
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          (!Boolean(_ctx.featureEntity.waitListStatus))
                            ? (_openBlock(), _createBlock(_component_dw_button, {
                                key: 0,
                                onClick: _ctx.onAddToWaitList
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Добавить в ЛО")
                                ]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", _hoisted_40, [
                          _createVNode(_component_dw_button, { onClick: _ctx.onAssign }, {
                            default: _withCtx(() => [
                              _createTextVNode("Назначить")
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_dw_button, { onClick: _ctx.onSelfDelivery }, {
                            default: _withCtx(() => [
                              _createTextVNode("Самопривоз")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ((_ctx.isDelivery || _ctx.isUndeliveredDelivery) && !Boolean(_ctx.featureEntity.waitListStatus))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createVNode(_component_dw_button, { onClick: _ctx.onAddToWaitList }, {
                            default: _withCtx(() => [
                              _createTextVNode("Добавить в ЛО")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}